import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="switch-view"
export default class extends Controller {

  static values = {
    url: String
  }

  connect() {
  }


  switch() {
    if (this.urlValue) {
      window.location.replace(this.urlValue + this.element.value)
    } else {
      window.location.replace(this.element.value)

    }
  }

}
